import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import {
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Typography,
  DatePicker,
  TimePicker,
  Button,
  message,
} from "antd";
import moment from "moment";
import { ArrowLeft } from "lucide-react";
import { useDispatch } from "react-redux";
import { createWellness } from "../../api/Schedule/createWellness";

export default function Index() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const today = moment(); // Today's date
  const [selectedMode, setSelectedMode] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  const onChangeDateStart = (values, dateString) => {
    const formattedDate = moment(dateString, "DD-MM-YYYY hh:mm a").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    // let date = moment(dateString, "YYYY-MM-DD hh:mm a").format(
    //   "YYYY-MM-DDTHH:mm"
    // );
    console.log("date====>", formattedDate, dateString);
    setStartTime(formattedDate);
  };
  const onChangeDateEnd = (values, dateString) => {
    const formattedDate = moment(dateString, "DD-MM-YYYY hh:mm a").format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    console.log("date====>", formattedDate, dateString);
    setEndTime(formattedDate);
  };
  const onFinish = (values) => {
    let userData;
    if (values.eventType === "SURVEY") {
      // Surveys are stored as virtual events with type SURVEY; the survey URL goes in meetingLink
      userData = JSON.stringify({
        organisationId: localStorage.getItem("organisationId"),
        title: values.title,
        eventType: "VIRTUAL",
        meetingLink: values.survey_link,
        startTime: startTime,
        endTime: endTime,
        type: "SURVEY",
        active: true,
        visibility: values.visibility,
      });
    } else if (values.eventType === "VIRTUAL") {
      userData = JSON.stringify({
        organisationId: localStorage.getItem("organisationId"),
        title: values.title,
        eventType: values.eventType,
        meetingLink: values.meeting_link,
        startTime: startTime,
        endTime: endTime,
        type: "WELLNESS_SESSION",
        active: true,
        visibility: values.visibility,
      });
    } else {
      userData = JSON.stringify({
        organisationId: localStorage.getItem("organisationId"),
        title: values.title,
        eventType: values.eventType,
        venue: values.venue,
        startTime: startTime,
        endTime: endTime,
        type: "WELLNESS_SESSION",
        active: true,
        visibility: values.visibility,
      });
    }
    dispatch(createWellness(userData)).then((res) => {
      if (res.payload?.status === "success") {
        message.success(
          values.eventType === "SURVEY" ? "Survey Created" : "Wellness Session Created"
        );
        form.resetFields();
        setSelectedMode(null);
      } else {
        message.error("Something went wrong");
      }
    });
  };
  const disabledDate = (current) => {
    return current.isBefore(today, "day");
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"}`}>
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="w-full bg-white">

            {/* Header */}
            <div className="flex justify-between items-center p-2 mb-3">
              <div className="flex justify-center items-center gap-2">
                <Button
                  className="flex items-center justify-center w-9 h-9 p-0 rounded-xl bg-white border-[1px] border-solid border-[#E2E8F0] shadow-sm hover:bg-[#F8FAFC] text-[#171717]"
                  onClick={() => window.history.back()}
                >
                  <ArrowLeft size={18} />
                </Button>
                <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
                  Schedule Wellness Session
                </h1>
              </div>
            </div>

            {/* Form Container */}
            <div className="bg-white border-[1px] border-solid border-[#E2E8F0] rounded-2xl shadow-sm p-[24px]">
              <Form
                form={form}
                name="wellness-form"
                layout="vertical"
                onFinish={onFinish}
                className="font-poppins"
              >
                {/* Title, Event Type and Visibility Row */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                  <Form.Item
                    label={<span className="font-poppins text-sm text-[#334155] font-medium">Title</span>}
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Title is required",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter Title"
                      className="font-poppins h-10 rounded-xl"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="font-poppins text-sm text-[#334155] font-medium">Event Type</span>}
                    name="eventType"
                    rules={[
                      {
                        required: true,
                        message: "Event Type is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Event Type"
                      className="font-poppins"
                      onChange={(v) => {
                        setSelectedMode(v);
                      }}
                      options={[
                        {
                          label: "Virtual",
                          value: "VIRTUAL",
                        },
                        {
                          label: "On Campus",
                          value: "ON_CAMPUS",
                        },
                        {
                          label: "Survey",
                          value: "SURVEY",
                        },
                      ]}
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="font-poppins text-sm text-[#334155] font-medium">Visibility</span>}
                    name="visibility"
                    rules={[{ required: true, message: "Visibility is required" }]}
                  >
                    <Select
                      placeholder="Select Visibility"
                      className="font-poppins"
                      options={[
                        { label: "Public", value: "PUBLIC" },
                        { label: "Private", value: "PRIVATE" },
                      ]}
                    />
                  </Form.Item>
                </div>

                {/* Date and Time Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <Form.Item
                    label={<span className="font-poppins text-sm text-[#334155] font-medium">Start Date & Time</span>}
                    name="start_date"
                    rules={[
                      {
                        required: true,
                        message: "Start date & time is required",
                      },
                    ]}
                  >
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      onChange={onChangeDateStart}
                      className="w-full font-poppins h-10 rounded-xl"
                      disabledDate={disabledDate}
                      format="DD-MM-YYYY HH:mm a"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<span className="font-poppins text-sm text-[#334155] font-medium">End Date & Time</span>}
                    name="end_date"
                    rules={[
                      {
                        required: true,
                        message: "End date time is required",
                      },
                    ]}
                  >
                    <DatePicker
                      showTime={{ use12Hours: true }}
                      onChange={onChangeDateEnd}
                      className="w-full font-poppins h-10 rounded-xl"
                      disabledDate={disabledDate}
                      format="DD-MM-YYYY HH:mm a"
                    />
                  </Form.Item>
                </div>

                {/* Venue/Meeting Link Row */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  {selectedMode === "VIRTUAL" ? (
                    <Form.Item
                      label={<span className="font-poppins text-sm text-[#334155] font-medium">Meeting Link</span>}
                      name="meeting_link"
                      rules={[
                        {
                          required: true,
                          message: "Meeting Link is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Meeting Link"
                        className="font-poppins h-10 rounded-xl"
                      />
                    </Form.Item>
                  ) : selectedMode === "ON_CAMPUS" ? (
                    <Form.Item
                      label={<span className="font-poppins text-sm text-[#334155] font-medium">Venue</span>}
                      name="venue"
                      rules={[
                        {
                          required: true,
                          message: "Venue is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Venue"
                        className="font-poppins h-10 rounded-xl"
                      />
                    </Form.Item>
                  ) : selectedMode === "SURVEY" ? (
                    <Form.Item
                      label={<span className="font-poppins text-sm text-[#334155] font-medium">Survey Link</span>}
                      name="survey_link"
                      rules={[
                        {
                          required: true,
                          message: "Survey Link is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Add URL of the survey form"
                        className="font-poppins h-10 rounded-xl"
                      />
                    </Form.Item>
                  ) : null}
                </div>

                {/* Submit Button */}
                <Form.Item className="mb-0">
                  <Button
                    htmlType="submit"
                    className="btn-gradient font-poppins font-semibold text-[13px] h-10 px-8 rounded-xl border-0"
                  >
                    Schedule Session
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
